import { Fragment, type ReactNode } from 'react';

export function SkeletonRepeat({ count, render }: { count: number; render: (index: number) => ReactNode }) {
  return Array.from({ length: count }, (_, i) => <Fragment key={i}>{render(i)}</Fragment>);
}
